/* eslint-disable import/prefer-default-export */
import { useLocalStoreData, useStoreData } from 'stores/hooks';
import {
  getServices,
  getServicesAsync,
  getServicesRequestStatus,
  getUser,
  getUserAsync,
  getUserRequestStatus,
} from './userSlice';

export function useUser() {
  return useStoreData(getUser, getUserRequestStatus, getUserAsync);
}

export function useServices() {
  return useLocalStoreData({
    dataGetter: getServices,
    requestStatusGetter: getServicesRequestStatus,
    thunk: getServicesAsync,
  });
}
